export enum VideoStatus {
  READY = "READY",
  TRANSCRIBING = "TRANSCRIBING",
  TRANSCRIPT_READY = "TRANSCRIPT READY",
  FETCHING = "FETCHING",
  COMPRESSING = "COMPRESSING",
  // AI-filtered: the evidence-judge marked this video NOT_EVIDENCE so it was
  // never fetched. Surfaced so users can still choose to fetch & use it.
  NOT_EVIDENCE = "NOT_EVIDENCE",
}

export interface VideoData {
  title: string;
  videoUrl: string;
  recordedOn: string;
  recordedBy?: string;
  uploadedOn: string;
  uploadedBy?: string;
  id: string;
  transcript: unknown;
  status: VideoStatus;
  fileType?: string;
}
